import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-beast-brown-800 text-castle-cream-100 p-2 text-center text-sm">
      <div className="container mx-auto flex flex-col items-center space-y-4 md:space-y-0">
        <div>&copy; 2025 Wedding Project. {t("footer.copyright")}</div>
      </div>
    </footer>
  );
};

export default Footer;
